import { render } from "./SkillsList.vue?vue&type=template&id=68bfee69"
import script from "./SkillsList.vue?vue&type=script&lang=js"
export * from "./SkillsList.vue?vue&type=script&lang=js"

import "./SkillsList.vue?vue&type=style&index=0&id=68bfee69&lang=scss"

import exportComponent from "/home/wf13/Develop/web/vue-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__